module.exports = __webpack_public_path__ + "static/media/clothes_01.d54128c7.png";